import { useCallback } from 'react'
import { usePriceIntentValueOrThrow } from '@/features/priceCalculator/usePriceIntent'
import { useOptimisticValue } from '@/utils/useOptimisticValue'
import { useChangeExternalInsurer } from './useChangeExternalInsurer'

export function useExternalInsurerId() {
  const priceIntent = usePriceIntentValueOrThrow()
  // Optimistic value improves UX here: we need to make a API call whenever an external insurer is selected
  // but the UI get's updated instantly.
  const [externalInsurerId, _setExternalInsurerId, revertExternalInsurerId] = useOptimisticValue(
    priceIntent.externalInsurer?.id,
  )
  const [changeExternalInsurer, changeExternalInsurerLoading] = useChangeExternalInsurer({
    onError: () => revertExternalInsurerId(),
  })

  const setExternalInsurerId = useCallback(
    (externalInsurerId?: string) => {
      _setExternalInsurerId(externalInsurerId)
      changeExternalInsurer(externalInsurerId)
    },
    [changeExternalInsurer, _setExternalInsurerId],
  )

  return [externalInsurerId, setExternalInsurerId, changeExternalInsurerLoading] as const
}
